import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c034658"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "cont" }
const _hoisted_2 = { class: "jx-tit" }
const _hoisted_3 = { class: "jx-left" }
const _hoisted_4 = {
  key: 0,
  class: "jx-subtitle"
}
const _hoisted_5 = ["onClick"]
const _hoisted_6 = /*#__PURE__*/_createTextVNode("全部课程 ")
const _hoisted_7 = { class: "group-block" }
const _hoisted_8 = {
  key: 0,
  class: "sidebar"
}
const _hoisted_9 = { class: "subject-cont" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = {
  class: "img-block",
  span: 8
}
const _hoisted_12 = ["src"]
const _hoisted_13 = {
  class: "cont-block",
  span: 16
}
const _hoisted_14 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RightOutlined = _resolveComponent("RightOutlined")!
  const _component_Card = _resolveComponent("Card")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _directive_widthoverflowtitle = _resolveDirective("widthoverflowtitle")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createVNode(_component_a_spin, {
      tip: "加载中...",
      spinning: _ctx.loading
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(["wrapper", _ctx.theme])
        }, [
          _createElementVNode("div", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.subject, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "jx-course",
                key: item.id
              }, [
                _createElementVNode("p", _hoisted_2, [
                  _createElementVNode("span", _hoisted_3, [
                    _createElementVNode("span", null, _toDisplayString(item.configName), 1),
                    (item.schoolCourseGroupIntro)
                      ? _withDirectives((_openBlock(), _createElementBlock("span", _hoisted_4, [
                          _createTextVNode(_toDisplayString(item.schoolCourseGroupIntro), 1)
                        ])), [
                          [_directive_widthoverflowtitle, item.schoolCourseGroupIntro]
                        ])
                      : _createCommentVNode("", true)
                  ]),
                  _createElementVNode("span", {
                    class: "jx-right",
                    onClick: ($event: any) => (_ctx.jumpToSubjectDetail(item))
                  }, [
                    _hoisted_6,
                    _createVNode(_component_RightOutlined)
                  ], 8, _hoisted_5)
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createVNode(_component_Card, {
                    gutter: 22,
                    span: 8,
                    courses: _ctx.formatModuleItems(item.moduleItems),
                    onJumpToCourse: _ctx.jumpToCourse
                  }, null, 8, ["courses", "onJumpToCourse"])
                ])
              ]))
            }), 128))
          ]),
          (_ctx.delicateList.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delicateList, (block) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "subject-block",
                      key: block.schoolCourseGroupCode
                    }, [
                      _createVNode(_component_a_row, { class: "sub-tit 12" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_col, {
                            span: 21,
                            class: "name"
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(block.configName), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(block.moduleItems, (course) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "subject-item",
                          key: course.courseNo,
                          onClick: ($event: any) => (_ctx.jumpToCourse({courseNo: course.courseNo,courseType: course.courseType}))
                        }, [
                          _createElementVNode("div", _hoisted_11, [
                            _createElementVNode("img", {
                              src: course.courseImageUrl,
                              alt: ""
                            }, null, 8, _hoisted_12)
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _withDirectives((_openBlock(), _createElementBlock("div", null, [
                              _createTextVNode(_toDisplayString(course.courseName), 1)
                            ])), [
                              [_directive_widthoverflowtitle, course.courseName]
                            ]),
                            _createElementVNode("p", {
                              title: course.courseIntro
                            }, _toDisplayString(course.mainTeacherName), 9, _hoisted_14)
                          ])
                        ], 8, _hoisted_10))
                      }), 128))
                    ]))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ]),
      _: 1
    }, 8, ["spinning"])
  ]))
}